export function chatLauncherEvents() {
	const triggers = Array.from(
		new Set([
			...document.querySelectorAll("[data-chat-launcher]"),
			...document.querySelectorAll('[data-ilawyer-button="chat-launcher"]'),
		])
	);
	if (!triggers.length) {
		return;
	}

	async function firstClick(e) {
		const trigger = e?.currentTarget || e?.target?.closest?.("[data-chat-launcher], [data-ilawyer-button=\"chat-launcher\"]");
		triggers.forEach((trigger) => trigger.removeEventListener("click", firstClick));
		try {
			const { initChatLauncher } = await import("./chat-launcher.js");
			const openChat = initChatLauncher(triggers);
			if (typeof openChat === "function") {
				openChat(trigger || e);
			}
		} catch (err) {
			console.error("Failed to load chat launcher:", err);
		}
	}

	triggers.forEach((trigger) => trigger.addEventListener("click", firstClick));
}
